import { getAllCity, getProvinceData, getList, getAreaData} from '@/api/dashboard'
import { setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import * as types from '../mutaion-types'

const dashboard = {
    state: {
    token: '',
    provinceName: ''
  },
  mutations: {
    [types.SET_TOKEN]: (state, token) => {
      state.token = token
    },
   [types.SET_PROVINCE]: (state, n) => {
      state.provinceName = n;
    }
  },
  actions: {
    setProvinceName({ commit }, { na_me }) {
      commit(types.SET_PROVINCE,na_me)
    },
    getAllCityData({ commit }, { }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await getAllCity()
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    getProvincesData({ commit }, { areano,syncTimeStart,syncTimeEnd }) {
        return new Promise(async (resolve, reject) => {
            try {
              const response = await getProvinceData( areano,syncTimeStart,syncTimeEnd )
              resolve(response)
            } catch (error) {
              reject(error)
            }
        })
    },
    getListData({ commit }, data ) {
        return new Promise(async (resolve, reject) => {
            try {
              const response = await getList( data )
              resolve(response)
            } catch (error) {
              reject(error)
            }
        })
    },
    getAreasData({ commit }, { areano,syncTimeStart,syncTimeEnd } ) {
        return new Promise(async (resolve, reject) => {
            try {
              const response = await getAreaData( areano,syncTimeStart,syncTimeEnd )
              resolve(response)
            } catch (error) {
              reject(error)
            }
        })
    },
  }
}

export default dashboard
